module.exports = __webpack_public_path__ + "img/D_Read_more_compare_male.b9682739.svg";